import styles from './style.module.scss';
import { Divider } from 'antd';

import { useState, useEffect, useRef } from 'react';
import leftImg from '@/assets/images/simulation/left_arrow.webp';
import rightImg from '@/assets/images/simulation/right_arrow.webp';
import transitionImg from '@/assets/images/simulation/transition_arrow.webp';
import { Display } from '@/components/Display/Display';
import SimulationImg from '../../../components/SimulationImg';
const CardListOverThree = (props) => {
    let { reportCards = [] } = props;
    const listRef = useRef(null);
    const [isAtLeft, setIsAtLeft] = useState(true);
    const [isAtRight, setIsAtRight] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showArrow, setShowArrow] = useState({
        left: false,
        right: false
    });

    const getScrollBoxEdge = () => {
        let scrollBox = listRef.current;
        const { scrollLeft, scrollWidth, clientWidth } = scrollBox;
        const isAtLeft = scrollLeft === 0;
        const isAtRight = scrollLeft >= scrollWidth - clientWidth - 1;
        return {
            isAtLeft,
            isAtRight
        };
    };
    useEffect(() => {
        const dom = listRef.current;
        const isOverflowing = dom.offsetWidth < dom.scrollWidth;
        let { isAtLeft, isAtRight } = getScrollBoxEdge();
        setShowArrow({
            left: isOverflowing && !isAtLeft,
            right: isOverflowing && !isAtRight
        });
        setIsOverflowing(isOverflowing);
    }, [isAtLeft, isAtRight, reportCards]);

    const onScroll = () => {
        let { isAtLeft, isAtRight } = getScrollBoxEdge();
        setIsAtLeft(isAtLeft);
        setIsAtRight(isAtRight);
    };
    const onClickArrow = (direction) => {
        let scrollBox = listRef.current;
        const { scrollLeft } = scrollBox;
        let left = scrollLeft;
        if (direction === 'left') {
            left = scrollLeft - 300;
        } else {
            left = scrollLeft + 300;
        }
        listRef.current.scrollTo({
            left: left,
            behavior: 'smooth'
        });
    };
    return (
        <>
            <div className={styles.eventTimelineWrap}>
                <Display show={showArrow.left}>
                    <div className={styles['arrowLeft']} onClick={() => onClickArrow('left')}>
                        <img src={leftImg} alt="left" />
                    </div>
                </Display>

                <div
                    data-left={isOverflowing && !isAtLeft}
                    data-right={isOverflowing && !isAtRight}
                    onScroll={onScroll}
                    ref={listRef}
                    className={styles.eventTimeline}
                >
                    {reportCards.map((ele, index) => {
                        return (
                            <div key={index} className={styles.flipCard}>
                                <div className={styles.flipCardInner}>
                                    <div className={styles.flipCardFront}>
                                        <div className={styles['event-index']}>{index > 8 ? index + 1 : '0' + (index + 1)}</div>
                                        <div className={styles['event-title']}>{ele.scenario_title}</div>
                                        <div>
                                            <SimulationImg className={styles['event-img']} src={ele?.scenario_image} alt={ele.scenario_title} />
                                        </div>
                                        <div className={styles['event-content']}>{ele.scenario_description}</div>
                                    </div>

                                    <div className={styles.flipCardBack}>
                                        <div className={styles['top']}>
                                            <div className={styles['choice-index']}>
                                                {index > 8 ? index + 1 : '0' + (index + 1)}
                                                <div className={styles['choice-title']}>你的选择</div>
                                            </div>

                                            <div className={styles['choice']}>{ele?.choice_path}</div>
                                        </div>

                                        <div className={styles['choice-split-line']}>
                                            <img src={transitionImg} alt={ele.scenario_title} />
                                            <Divider
                                                style={{
                                                    borderColor: '#D9D9D9',
                                                    marginTop: '6px',
                                                    marginBottom: '12px',
                                                    fontSize: '14px',
                                                    color: '#8C8C8C'
                                                }}
                                                dashed
                                            >
                                                产生影响
                                            </Divider>
                                        </div>
                                        <div className={styles['bottom']}>
                                            <div className={styles['choice-content']}>{ele?.impact_analysis}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <Display show={showArrow.right}>
                    <div className={styles['arrowRight']} onClick={() => onClickArrow('right')}>
                        <img src={rightImg} alt="right" />
                    </div>
                </Display>
            </div>
        </>
    );
};
export default CardListOverThree;
